import { useMsal } from "@azure/msal-react";
import { useUserByEmail } from "@/services/settings";
import type { UserResponse } from "@/types/settings";

/**
 * Returns the current user's full profile from the API by email lookup.
 * Mirrors the Blazor pattern: identify signed-in user by email, fetch their profile via GetuserByEmailAsync.
 */
export function useCurrentUser(): UserResponse | undefined {
  const { accounts } = useMsal();
  const email = accounts[0]?.username ?? "";
  const { data } = useUserByEmail(email);
  return data;
}

/**
 * Returns true if the currently signed-in user has the "Admin" role,
 * as determined by the user permission API response (roleName field).
 */
export function useIsAdmin(): boolean {
  const currentUser = useCurrentUser();
  return currentUser?.roleName?.toLowerCase() === "admin";
}
